export const RETRY_DELAY = 2000;
export const MAX_RETIRES = 2;
